/* @flow */
import React from 'react';
import { RouterProps } from 'react-router';
import Avatar from './AvatarDropdown';
import styles from './GlobalHeader.module.pcss';

type Props = {
  auth: AuthT,
  routerProps: RouterProps,
  signOut: () => void,
};

const RightContent = (props: Props) => {
  return (
    <span className={styles.right}>
      <Avatar {...props} />
    </span>
  );
};

export default RightContent;
